export const SHOW_WORKFLOW_ICON_SETTING = 'SHOW_WORKFLOW_ICON';